export const menuOptions = [
  {
    value: "Ana Sayfa",
    text: "Ana Sayfa"
  },
  {
    value: "Yük Listesi",
    text: "Yük Listesi"
  },
  {
    value: "Yük Borsası",
    text: "Yük Borsası"
  },
  {
    value: "Profilim",
    text: "Profilim"
  },
  {
    value: "Bildirimler",
    text: "Bildirimler"
  },
  {
    value: "Yük Bildirimi / E-İrsaliye / E-Fatura",
    text: "Yük Bildirimi / E-İrsaliye / E-Fatura"
  },
  {
    value: "Maliyet Hesabı",
    text: "Maliyet Hesabı"
  },
  {
    value: "Referans Kartı",
    text: "Referans Kartı"
  },
  {
    value: "İlanlar",
    text: "İlanlar"
  },
  {
    value: "Akıllı Kamyoon",
    text: "Akıllı Kamyoon"
  },
  {
    value: "Uygun Sigorta Bul",
    text: "Uygun Sigorta Bul"
  },
  {
    value: "İletişim",
    text: "İletişim"
  },
  {
    value: "Yakınımdaki Yerler",
    text: "Yakınımdaki Yerler"
  },
  {
    value: "Kamyon Garajları Yoğunluğu",
    text: "Kamyon Garajları Yoğunluğu"
  },
  {
    value: "İndirimler",
    text: "İndirimler"
  }, 
  {
    value: "Yedek Parça Ana Sayfa",
    text: "Yedek Parça"
  },
];
 
export const subMenuOptions = [
  {
    mainMenu: "Ana Sayfa",
    value: null,
    text: "Ana Sayfa"
  },
  {
    mainMenu: "Yük Listesi",
    value: "Yük Listesi",
    text: "Yük Listesi"
  },
  {
    mainMenu: "Yük Borsası",
    value: null,
    text: "Yük Borsası"
  },
  {
    mainMenu: "Yük Listesi",
    value: "Yukler",
    text: "Yükler Sayfası"
  },
  {
    mainMenu: "Yük Listesi",
    value: "Tekliflerim",
    text: "Tekliflerim"
  },
  {
    mainMenu: "Yük Listesi",
    value: "Sevkiyatlarım",
    text: "Sevkiyatlarım"
  },
  {
    mainMenu: "Yük Listesi",
    value: "Yük Arıyorum",
    text: "Yük Arıyorum"
  },
  {
    mainMenu: "Profilim",
    value: "ProfilePageMain",
    text: "Profil Ana Menu"
  },
  {
    mainMenu: "Profilim",
    value: "Bilgilerim",
    text: "Bilgilerim"
  },
  {
    mainMenu: "Profilim",
    value: "Belgelerim",
    text: "Belgelerim"
  },
  {
    mainMenu: "Profilim",
    value: "Araçlarım",
    text: "Araçlarım"
  },
  {
    mainMenu: "Profilim",
    value: "Sürücülerim",
    text: "Sürücülerim"
  },
  {
    mainMenu: "Profilim",
    value: "Sürücülerim",
    text: "Sürücülerim"
  },
  {
    mainMenu: "Bildirimler",
    value: "Bildirimler",
    text: "Bildirimler"
  },
  {
    mainMenu: "Yük Bildirimi / E-İrsaliye / E-Fatura",
    value: "BildirimTuruSecimi",
    text: "Bildirim Seçim / Fatura Ekranı"
  },
  {
    mainMenu: "Yük Bildirimi / E-İrsaliye / E-Fatura",
    value: "IrsalyeSayfası",
    text: "Yük Bildirimi Ekranı"
  },
  {
    mainMenu: "Maliyet Hesabı",
    value: "MaliyetHesabiSecmeEkrani",
    text: "Maliyet Hesabı Ana Sayfa"
  },
  {
    mainMenu: "Referans Kartı",
    value: "ReferansKartiSayfasi",
    text: "Referans Kartı Anasayfa"
  },
  {
    mainMenu: "İlanlar",
    value: "IlanlarMainPage",
    text: "İlanlar Ana Sayfa"
  },
  {
    mainMenu: "İlanlar",
    value: "SurucuOlarakIsAriyorum",
    text: "Sürücü Olarak İş Arıyorum İlanı Form"
  },
  {
    mainMenu: "İlanlar",
    value: "SurucuAriyorum",
    text: "Sürücü Arıyorum İlanı Form"
  },
  {
    mainMenu: "İlanlar",
    value: "SurucuAriyorum",
    text: "Sürücü Arıyorum İlanı Form"
  },
  {
    mainMenu: "İlanlar",
    value: "KiralikAracAriyorum",
    text: "Kiralık Araç Arıyorum İlanı Form"
  },
  {
    mainMenu: "İlanlar",
    value: "EklenecekIlanTuruSecme",
    text: "Eklenecek İlan Türü Seçme"
  },
  {
    mainMenu: "İlanlar",
    value: "Ilanlarim",
    text: "İlanlarım"
  },
  {
    mainMenu: "Akıllı Kamyoon",
    value: null,
    text: "Akıllı Kamyoon"
  },
  {
    mainMenu: "Uygun Sigorta Bul",
    value: "SigortaTeklifiSecimEkrani",
    text: "Sigorta Ana Sayfa"
  },
  {
    mainMenu: "Uygun Sigorta Bul",
    value: "AracBilgileriyleTeklifAl",
    text: "Araç Bilgileri İle Teklif Al"
  },
  {
    mainMenu: "İletişim",
    value: null,
    text: "İletişim"
  },
  {
    mainMenu: "Yakınımdaki Yerler",
    value: "NearByPermissions",
    text: "Yakınımdaki Yerler Ana Sayfa"
  },
  {
    mainMenu: "Kamyon Garajları Yoğunluğu",
    value: null,
    text: "Kamyon Garajları Yoğunluğu"
  },
  {
    mainMenu: "İndirimler",
    value: "MainPage",
    text: "İndirimler Ana Sayfa"
  },
  {
    mainMenu: "İndirimler",
    value: "Yetki belgesi",
    text: "Yetki belgesi"
  },
  {
    mainMenu: "Yedek Parça Ana Sayfa",
    value: null,
    text: "Yedek Parça"
  }
];
 
 
export const sendOptions = [
  {
    id: 3,
    text: "Hemen Gönder"
  },
  {
    id: 2,
    text: "İleri Bir Tarihte Gönder"
  },
  {
    id: 1,
    text: "Haftalık Gönder (Sürekli)"
  },
  {
    id: 0,
    text: "Aylık Gönder (Sürekli)"
  },
]